export class SseParser {
	#response: Response;
	#data = "";
	#eventType = "";
	#lastEventId = "";

	constructor(response: Response) {
		this.#response = response;
	}

	#dispatchEvent(): MessageEvent | undefined {
		if (this.#data.length === 0) {
			this.#eventType = "";
			return;
		}

		if (this.#data.endsWith("\n")) {
			this.#data = this.#data.slice(0, -1);
		}

		const event = new MessageEvent(
			this.#eventType.length > 0 ? this.#eventType : "message",
			{
				data: this.#data,
				origin: new URL(this.#response.url).origin,
				lastEventId: this.#lastEventId,
			},
		);

		this.#data = "";
		this.#eventType = "";

		return event;
	}

	#processField(field: string, value: string): void {
		switch (field) {
			case "event": {
				this.#eventType = value;
				break;
			}
			case "data": {
				this.#data += `${value}\n`;
				break;
			}
			case "id": {
				if (value.includes("\x00")) {
					break;
				}
				this.#lastEventId = value;
				break;
			}
		}
	}

	async *parse(): AsyncGenerator<MessageEvent> {
		if (!this.#response.body) {
			return;
		}

		const reader = this.#response.body
			.pipeThrough(new TextDecoderStream())
			.getReader();
		try {
			while (true) {
				const { done, value: chunk = "" } = await reader.read();
				if (done) {
					break;
				}

				for (const line of chunk.split("\n")) {
					if (line.length === 0) {
						const event = this.#dispatchEvent();
						if (event) {
							yield event;
						}
						continue;
					}

					if (line.startsWith(":")) {
						continue;
					}

					let field = "";
					let value = "";
					const colonIndex = line.indexOf(":");
					if (colonIndex >= 0) {
						field = line.slice(0, colonIndex);
						value = line.slice(colonIndex + 1);
						if (value.startsWith(" ")) {
							value = value.slice(1);
						}
					} else {
						field = line;
					}
					this.#processField(field, value);
				}
			}
		} finally {
			reader.releaseLock();
		}
	}
}
